<template>
  <v-row>
    <v-col v-for="control in timerControls" :key="control.icon" cols="auto">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            height="30"
            color="primary"
            @click="$emit('action', control.action)"
            :disabled="control.isDisabled"
          >
            <v-icon v-if="control.icon" :color="control.color">{{
              control.icon
            }}</v-icon>
            <span v-else>{{ control.lable }}</span>
          </v-btn>
        </template>
        <span>{{ control.tooltip }}</span>
      </v-tooltip>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "TimerActions",
  props: {
    status: {
      value: String,
      default: "",
    },
  },
  computed: {
    isDisabled() {
      return true;
    },
    actionStatus() {
      return this.status;
    },
    timerControls() {
      return [
        {
          icon: "mdi-play",
          action: "play",
          isDisabled: this.actionStatus === "Started",
          tooltip: this.$t("agenda.tipPlay"),
        },
        {
          icon: "mdi-pause",
          action: "pause",
          isDisabled: this.actionStatus !== "Started",
          tooltip: this.$t("agenda.tipPause"),
        },
        {
          icon: "mdi-stop",
          action: "stop",
          isDisabled:
            this.actionStatus === null ||
            this.actionStatus === "" ||
            this.actionStatus === "Finished",
          tooltip: this.$t("agenda.tipStop"),
        },
        {
          lable: this.$t("agenda.tipReset"),
          action: "reset",
          isDisabled: false,
          tooltip: this.$t("agenda.tipReset"),
        },
      ];
    },
  },
};
</script>

<style>
</style>